/**
 * 学年一覧取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import { ApiResponseGrade } from '@/models/apiResponses/grades'

@Component
export default class GradesApi extends Vue {
  /**
   * 学年一覧取得
   * @returns 学年一覧
   */
  protected async getGrades(): Promise<ApiResponseGrade[]> {
    const { data }: { data: ApiResponseGrade[] } = await Vue.prototype.$http.httpWithToken
      .get('/v2/grades')
      .catch(() => ({ data: [] }))

    return data
  }
}
